module.exports = __webpack_public_path__ + "img/shanchu.48ff7563.png";